<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent()"
  [title]="titleWebPage"
  start="{{ startStage }}"
  end="{{ endStage }}"
></app-ion-common-header>

<ion-content
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <app-ion-common-label
    [id]="idLabelNumber"
    class="document-type-label1"
    labelStyle="display-rg"
    [labelDescription]="title"
    [labelAria]="labelAria"
  >
  </app-ion-common-label>

  <div class="conent-center conent-center--mrt-lg">
    <form [formGroup]="numberForm" (ngSubmit)="submitForm($event)">
      <app-ion-common-input
        [fieldValue]="number"
        [placeholder]="placeholder"
        [maxLength]="maxLength"
        [error]="error"
        (textChange)="number = $event; errorMsg()"
        [textError]="textError"
        [id]="idComponentNumber"
        [type]="type"
        [idLabel]="idLabel"
        [replaceStrTo]="replaceStrTo"
        [label]="label"
        name="docNumber"
        [disabled]="!this.edit"
        formControlName="docNumber"
        ngDefaultControl
      >
      </app-ion-common-input>
    </form>
  </div>
  <app-ion-common-button
    [id]="idButtonNumber"
    class="hidden"
    [ngClass]="{ hidden: !buttonEnable || number.length === 0 }"
    [attr.aria-hidden]="!buttonEnable"
    label="Continuar"
    (clickButton)="clickNext()"
  ></app-ion-common-button>
</ion-content>
